import { render, staticRenderFns } from "./AppointmentTypeView.vue?vue&type=template&id=1fd792d5"
import script from "./AppointmentTypeView.vue?vue&type=script&lang=js"
export * from "./AppointmentTypeView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports